import { useState } from "react";
import ExpertCard from "../components/modules/experts/ExpertCard";
import BookingPopup from "../components/modules/experts/BookingPopup";
import expertsData from "../data/expertsData";

export default function Experts() {
  const [selectedExpert, setSelectedExpert] = useState(null);
  const [showBooking, setShowBooking] = useState(false);

  const handleBookClick = (expert) => {
    setSelectedExpert(expert);
    setShowBooking(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseBooking = () => {
    setShowBooking(false);
    setSelectedExpert(null);
    document.body.style.overflow = 'unset';
  };

  const handleBookingSubmit = (expert) => {
    alert(`✅ Booking request sent to ${expert.name}!`);
    handleCloseBooking();
  };

  return (
    <div>
      <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-5 py-8 sm:px-8 sm:py-10 mb-6">
        <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
          Expert Marketplace
        </span>
        <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2">
          Consult 260+ Industry Experts
        </h1>
        <p className="text-indigo-100 max-w-2xl text-sm sm:text-base">
          Book time with domain leaders across additive manufacturing,
          robotics, EV, PCB and more.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
        {expertsData.map((expert) => (
          <ExpertCard 
            key={expert.name} 
            expert={expert} 
            onBookClick={handleBookClick}
          />
        ))}
      </div>

      {/* Booking Popup */}
      {showBooking && selectedExpert && (
        <BookingPopup
          expert={selectedExpert}
          onClose={handleCloseBooking}
          onSubmit={handleBookingSubmit}
        />
      )}
    </div>
  );
}


// import { useState, useEffect } from "react";
// import ExpertCard from "../components/modules/experts/ExpertCard";
// import BookingPopup from "../components/modules/experts/BookingPopup";
// import expertService from "../service/expertService";
// import { Loader2 } from "lucide-react"; // ✅ Add this import
// import { useToast } from "../../context/ToastContext"; // ✅ Add this import

// export default function Experts() {
//   const [experts, setExperts] = useState([]);
//   const { showToast } = useToast(); // ✅ Add this hook
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [selectedExpert, setSelectedExpert] = useState(null);
//   const [showBooking, setShowBooking] = useState(false);

//   useEffect(() => {
//     fetchExperts();
//   }, []);

//   const fetchExperts = async () => {
//     setLoading(true);
//     setError("");

//     try {
//       const response = await expertService.getExpertCourses();
//       console.log("Experts response:", response);

//       let expertsData = [];
//       if (Array.isArray(response)) {
//         expertsData = response;
//       } else if (response.data && Array.isArray(response.data)) {
//         expertsData = response.data;
//       } else if (response.success && response.data && Array.isArray(response.data)) {
//         expertsData = response.data;
//       } else {
//         expertsData = [];
//         setError(response.message || "No experts found.");
//       }

//       setExperts(expertsData);
//     } catch (err) {
//       console.error("Error fetching experts:", err);
//       setError(err.message || "Failed to load experts. Please try again.");
//       setExperts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleBookClick = (expert) => {
//     setSelectedExpert(expert);
//     setShowBooking(true);
//     document.body.style.overflow = 'hidden';
//   };

//   const handleCloseBooking = () => {
//     setShowBooking(false);
//     setSelectedExpert(null);
//     document.body.style.overflow = 'unset';
//   };

//   const handleBookingSubmit = async (bookingData) => {
//     try {
//       const response = await expertService.bookExpert(bookingData);
//       console.log("Booking response:", response);

//       if (response.success || response.id || response.bookingId) {
//         showToast(`✅ Booking confirmed with ${selectedExpert?.mentorName || selectedExpert?.name}!`, "success");
//       } else {
//         showToast("Booking failed: " + (response.message || "Please try again."), "error");
//       }
//     } catch (err) {
//       console.error("Booking error:", err);
//       showToast("Booking failed. Please try again.", "error");
//     }
//     handleCloseBooking();
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <Loader2 className="w-8 h-8 text-indigo-600 animate-spin" />
//         <span className="ml-3 text-gray-600">Loading experts...</span>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div>
//         <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-5 py-8 sm:px-8 sm:py-10 mb-6">
//           <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
//             Expert Marketplace
//           </span>
//           <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2">
//             Consult 260+ Industry Experts
//           </h1>
//           <p className="text-indigo-100 max-w-2xl text-sm sm:text-base">
//             Book time with domain leaders across additive manufacturing,
//             robotics, EV, PCB and more.
//           </p>
//         </div>
//         <div className="h-40 flex items-center justify-center text-red-500 border border-red-200 bg-red-50 rounded-2xl">
//           {error}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div>
//       <div className="bg-gradient-to-br from-[#1e1b4b] via-[#312e81] to-[#4c1d95] text-white rounded-2xl px-5 py-8 sm:px-8 sm:py-10 mb-6">
//         <span className="inline-block text-xs font-semibold bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
//           Expert Marketplace
//         </span>
//         <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2">
//           Consult {experts.length}+ Industry Experts
//         </h1>
//         <p className="text-indigo-100 max-w-2xl text-sm sm:text-base">
//           Book time with domain leaders across additive manufacturing,
//           robotics, EV, PCB and more.
//         </p>
//       </div>

//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
//         {experts.map((expert) => (
//           <ExpertCard
//             key={expert.id || expert.expertId}
//             expert={expert}
//             onBookClick={handleBookClick}
//           />
//         ))}
//       </div>

//       {experts.length === 0 && !loading && (
//         <div className="h-40 flex items-center justify-center text-gray-400 border border-dashed border-gray-200 rounded-2xl">
//           No experts available at the moment.
//         </div>
//       )}

//       {/* Booking Popup */}
//       {showBooking && selectedExpert && (
//         <BookingPopup
//           expert={selectedExpert}
//           onClose={handleCloseBooking}
//           onSubmit={handleBookingSubmit}
//         />
//       )}
//     </div>
//   );
// }